var HeavyBaggage = /** @class */ (function () {
    function HeavyBaggage() {
        this.checked = false;
        this.errorMsg = {};
        this.validation = {};
    }
    return HeavyBaggage;
}());
export default HeavyBaggage;
